import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import {useStore} from 'src/feature/store/hook'
import StoreList from '../List'
import {useGetList} from '../../context/useQuery'
import {useEffect, useState} from 'react'
import LocationDetail from './Location/LocationDetail'
import {useLocation} from 'react-router-dom'

const StoreStores = ({isCorporate}: {isCorporate?: boolean}) => {
  const intl = useIntl()
  const location = useLocation()

  const {detail, detailSet, tabFilter, tabFilterSet} = useStore()
  const {isLoading} = useGetList()
  const [isDetail, setIsDetail] = useState({
    status: false,
    id: '',
  })

  const data = detail?.Subscription?.dataList || []
  const paging = detail?.Subscription?.paging || {
    currentPageNumber: 0,
    totalPagesNumber: 0,
    pageSize: 0,
    totalCount: 0,
  }

  useEffect(() => {
    // scroll top initial load
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <div className='card' id='kt_profile_details_view'>
        {!isDetail.status && (
          <>
            <div className='card-header'>
              <div className='card-title m-0'>
                <div>
                  <h3 className='fw-bold mb-2 mt-5'>
                    {intl.formatMessage({id: 'STORE.LOCATIONS'})}
                  </h3>
                  <p className='text-muted fw-normal fs-6'>
                    Manage and view all your registered locations in one place. This section
                    provides an overview of each location's key details, allowing you to manage them
                    efficiently.
                  </p>
                </div>
              </div>

              <div className='card-toolbar'>
                <div className='d-flex justify-content-end' data-kt-customer-table-toolbar='base'>
                  <div className='d-flex align-items-center gap-2 gap-lg-3'>
                    <a
                      className='btn btn-light d-flex align-items-center'
                      data-bs-toggle='tooltip'
                      data-bs-placement='left'
                      data-bs-dismiss='click'
                      data-bs-trigger='hover'
                      id='kt_filter_toggle'
                      href={`/new-location/${isCorporate ? 'corporate' : 'freelancer'}`}
                    >
                      <i className='bi bi-plus fs-3 me-3'></i>
                      <span>Add New Location</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {!isDetail.status && (
          <div className='card-body pt-0'>
            <StoreList loading={isLoading} isDetail={isDetail} setIsDetail={setIsDetail} />
          </div>
        )}
      </div>

      {isDetail.status && (
        <LocationDetail isDetail={isDetail} setIsDetail={setIsDetail} isCorporate={isCorporate} />
      )}
    </>
  )
}

export default StoreStores
